// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.context_menu {
    display: inline-block;
    color: var(--color-text);
    user-select: none;
}

.context_menu__backdrop {
    position: fixed;
    inset: 0;
    z-index: 2999;
}

.context_menu__popup {
    position: absolute;
    border: 1px solid var(--color-border);
    background-color: var(--color-bg-2);
    border-radius: 3px;
    z-index: 3000;
    min-width: 100%;
    box-shadow: 0 4px 13px rgba(0, 0, 0, 0.3);
    list-style: none;
    margin: 0;
    padding: 2px 0;
}

.context_menu__option {
    padding: 4px 11px;
    font-size: 15px;
    cursor: pointer;
    white-space: nowrap;
    color: var(--color-text);
}

.context_menu__option.disabled {
    cursor: default;
    color: var(--color-text-muted);
}

@media (pointer: fine) {
    .context_menu__option:not(.disabled):hover,
    .context_menu__option.focused:not(.disabled) {
        background-color: var(--color-bg-3);
    }
}
`, "",{"version":3,"sources":["webpack://./components/toolkit/ContextMenu/s.context_menu.css"],"names":[],"mappings":"AAAA;IACI,qBAAqB;IACrB,wBAAwB;IACxB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,QAAQ;IACR,aAAa;AACjB;;AAEA;IACI,kBAAkB;IAClB,qCAAqC;IACrC,mCAAmC;IACnC,kBAAkB;IAClB,aAAa;IACb,eAAe;IACf,yCAAyC;IACzC,gBAAgB;IAChB,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,mBAAmB;IACnB,wBAAwB;AAC5B;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI;;QAEI,mCAAmC;IACvC;AACJ","sourcesContent":[".context_menu {\n    display: inline-block;\n    color: var(--color-text);\n    user-select: none;\n}\n\n.context_menu__backdrop {\n    position: fixed;\n    inset: 0;\n    z-index: 2999;\n}\n\n.context_menu__popup {\n    position: absolute;\n    border: 1px solid var(--color-border);\n    background-color: var(--color-bg-2);\n    border-radius: 3px;\n    z-index: 3000;\n    min-width: 100%;\n    box-shadow: 0 4px 13px rgba(0, 0, 0, 0.3);\n    list-style: none;\n    margin: 0;\n    padding: 2px 0;\n}\n\n.context_menu__option {\n    padding: 4px 11px;\n    font-size: 15px;\n    cursor: pointer;\n    white-space: nowrap;\n    color: var(--color-text);\n}\n\n.context_menu__option.disabled {\n    cursor: default;\n    color: var(--color-text-muted);\n}\n\n@media (pointer: fine) {\n    .context_menu__option:not(.disabled):hover,\n    .context_menu__option.focused:not(.disabled) {\n        background-color: var(--color-bg-3);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
